"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.consumptionContext = exports.determineConsumptionBlockReason = exports.standingContexts = void 0;
var date_fns_1 = require("date-fns");
var core_1 = require("../../../../../../../shared/core");
var date_1 = require("../../../../../utils/date");
var values_1 = require("../../../../../utils/values");
function formatRange(startDate, endDate) {
    if (startDate === endDate) {
        return "on ".concat((0, date_1.formatDate)(startDate, 'd MMM'));
    }
    return "from ".concat((0, date_fns_1.isSameMonth)(startDate, endDate)
        ? (0, date_1.formatDate)(startDate, 'd')
        : (0, date_1.formatDate)(startDate, 'd MMM'), "-").concat((0, date_1.formatDate)(endDate, 'd MMM'));
}
function standingContexts(rates) {
    if (rates.length === 1) {
        return rates.map(function (_a) {
            var days = _a.days, rate = _a.rate;
            var dayStr = days === 1 ? '1 day' : "".concat(days, " days");
            return "".concat(dayStr, " at ").concat((0, core_1.minor2DP)(rate.pence), " per day");
        });
    }
    return rates.map(function (_a) {
        var days = _a.days, rate = _a.rate, startDate = _a.startDate, endDate = _a.endDate;
        var dayStr = days === 1 ? '1 day' : "".concat(days, " days");
        var perDay = days === 1 ? '' : ' per day';
        var rangeString = formatRange(startDate, endDate);
        return "".concat(dayStr, " at ").concat((0, core_1.minor2DP)(rate.pence)).concat(perDay, " ").concat(rangeString);
    });
}
exports.standingContexts = standingContexts;
function determineConsumptionBlockReason(rates) {
    return rates.map(function (rate, index) {
        var blockReason = 'Other';
        if (rate.closingReadType === 'MexReadingFinal' &&
            rates.length > index + 1 &&
            rates[index + 1].openingReadType === 'MexReadingInitial') {
            blockReason = 'MexFinal';
        }
        else if (rate.openingReadType === 'MexReadingInitial' &&
            index > 0 &&
            rates[index - 1].closingReadType === 'MexReadingFinal') {
            blockReason = 'MexInitial';
        }
        return __assign({ consumptionBlockReason: blockReason }, rate);
    });
}
exports.determineConsumptionBlockReason = determineConsumptionBlockReason;
function describeConsumptionBlock(consumptionBlockReason) {
    switch (consumptionBlockReason) {
        case 'MexFinal':
            return ' on your old meter';
        case 'MexInitial':
            return ' on your new meter';
        default:
            return '';
    }
}
function consumptionContext(label, _a, nonUniqueConsumptionBlock) {
    var kwh = _a.kwh, rate = _a.rate, startDate = _a.startDate, endDate = _a.endDate, consumptionBlockReason = _a.consumptionBlockReason;
    // If there is more than 1 consumption block in the bill period, we add the dates to distinguish them
    var dateSuffix = nonUniqueConsumptionBlock
        ? " ".concat(formatRange(startDate, endDate))
        : '';
    // If the rate is half hourly the rate is the average of all the charges
    var halfHourlyNote = label === 'Half Hourly' ? ' an average of' : '';
    return "".concat((0, values_1.round)(kwh), " kWh at").concat(halfHourlyNote, " ").concat((0, core_1.minor2DP)(rate.pence, 'GBX')).concat(dateSuffix).concat(describeConsumptionBlock(consumptionBlockReason));
}
exports.consumptionContext = consumptionContext;
